import React, { Component, PureComponent } from 'react'
import { View, Platform, StyleSheet} from 'react-native'
import {
	JDText, JDTouchable, JDImage,
	JDDevice, JDShare, JDToast, JDModal, JDScrollView
} from '@jdreact/jdreact-core-lib'
import getCity from '../../utils/lbs/index';
import PropTypes from 'prop-types'

import { 
	getZufangAreaList,
	getZufangSearchCondition,
	getZufangSearchList
 } from '../../utils/api'
import { pt, isJDApp, isWX, isWQ, sendClickDataWithJsonParam, sendExposureData, sendPv, jumpByUrl } from '../../components/utiles';
import { isPhoneX, isHarmonyWeb, harmonyWebShare, isJDAppWebView } from "../../utils/tools";
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../utils/steep';
import { cacheUtil, CacheKeyEnum } from '../../utils/cacheManager';

import JDCNavigationBar from '../../components/JDCNavigationBar';
import SearchBanner from './components/searchBanner';
import MaintabSearch from "./components/mainSearchBar"
import SearchPage from './components/searchPage';
import CityList from './components/cityList'
import FloatEntry from './components/floatEntry'
import EmptyCard from './components/EmptyCard'
import HouseSourceItem from './components/houseItemCard'
import FlatListFooter from '../../components/FlatListFooter'

import shareBlack from '../../images/shareBlack.png'
import errpageImg from '../../images/detail/errpage.png'
import skeletonImg from '../../images/detail/skeleton.png'

const webModalBoxId = 'maintabsearchModal';

const isWeb = Platform.OS === 'web';
const Page_Id = 'OfficeBuilding_SearchList'
const justLiulanqiHead = isWeb ? ((isJDApp || isWX || isWQ) ? 0 : JDDevice.getRpx(88)) : NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT
let wrapperLayoutTop = 0
export const isEmptyObj = function(obj){
  if(typeof obj === 'undefined' || obj === null || obj === ''){
    return true
  } else {
    return false
  }
}

export default class ZufangSearch extends PureComponent{
	static contextTypes = {
		router: PropTypes.object
	};
	constructor(props) {
		super(props);

		this.state = {
			statusData: {
				isListFetching: false,  // 正在加载数据
				error: null,            // 出错
				firstGet: false,          // 在第一次数据请求返回之前，不设置加载圈
				hasNext: true, // 是否还有数据
				isLastPage: false // 是否是最后一页
			},
			recommendHouse: [],
			keyWord:'', // 搜索关键字
			cityInfo: {},
			searchObj:{},
			areaList: [],
			searchCondition:{},
			positionInfo: {},
			isPositionSucc: false,
			isTabSticky: false, // 筛选是否吸顶
			showPop: false, // 是否展示筛选弹层
			showPopSearch: false, // 是否展示搜索中间页
			isShowCityPicker: false, // 是否展示城市弹层
			isLoading: false,	// 是否正在请求数据
			isShowErrMsg: false, // 是否展示错误信息
			errMsg: "", // 提示的错误信息
			isErrPage: false,
		};
		layoutData = [];
		// 已曝光的数据
		this.exposedList = [];
		this.recommendHouseParams = {
			pageNo: 1,
			isLoading: false,
			noMoreData: false
		}
		this.pageSize = 10
		this.tabOffsetTop = 0; // 筛选栏的滚动距离
    this.tabHeight = 0; // 筛选栏的高度
		this.HeadTitleHeight = 0
		this.pageScrollY = 0
		this.navBar = React.createRef();
		this.zufangPageScrollView = React.createRef();
		this.popSearchRef = React.createRef();
		this.tabBarRef = React.createRef();
		this.containerRef = React.createRef();
		this.nowUrlObj = {}
	}

	UNSAFE_componentWillMount(){
    this.getUrlObjAndUnitPage()
  }

  getUrlObjAndUnitPage = () => {
			const {
				title, 
				countyId, 
				streetIds, 
				minRentPrice,
				maxRentPrice,
				minTradePrice,
				maxTradePrice,
				roomAreaIds,
				houseType,
				subHouseType,
				cityId,
				cityName
			} = this.props
      const strTitle = title ? decodeURI(title) : ''
      const strCName = cityName ? decodeURI(cityName) : ''
      const numCityId = Number(cityId)

			const pageUrlObj = Object.assign({}, {
				title: strTitle, 
				countyId, 
				streetIds, 
				minRentPrice,
				maxRentPrice,
				minTradePrice,
				maxTradePrice,
				roomAreaIds,
				houseType,
				subHouseType,
				cityId: numCityId});
			Object.keys(pageUrlObj).forEach(item => {
					if(isEmptyObj(pageUrlObj[item])) {
							delete pageUrlObj[item]
					}
			})

			if (numCityId) {
				this.setState({
					searchObj: pageUrlObj,
					keyWord: strTitle, // 搜索关键字
					cityInfo: {
						cityId: numCityId,
						cityName: strCName,
					},
				},()=>{
					if (isWeb && cacheUtil.getCacheFlag('_list')) { // 不用定位
							this.catchAndInitPage()
					} else {
						//需要定位，但是不走定位后逻辑，用路径上cityid渲染页面
						this.getListData()
						this.justLocation()
					}
				})
				sendPv({ pageId: Page_Id, pageParam: ''+numCityId });
        this.getAreaList(numCityId)
			} else {
				this.setState({
					searchObj: pageUrlObj,
					keyWord: strTitle, // 搜索关键字
				})
        this.getUserLocation()
			}
  }

  getUserLocation = () => {
		getCity().then(res => {
			this._changePositionInfo(res)
		}).catch(()=>{
			this._changePositionInfo({isPositionSucc: false,cityId:'', cityName: '', open: false, lat: '', lon: ''})
		});
	}

	justLocation = () => {
		getCity().then(res => {
			const {isPositionSucc,cityId, cityName, open, lat, lon } = res
			this.setState({
					isPositionSucc,
					positionInfo: {
							cityId,
							cityName,
							open,
							lon,
							lat
					}
			})
		}).catch(()=>{
			this.setState({
					isPositionSucc: false,
					positionInfo: {
							cityId: '',
							cityName: '',
							open: false,
							lon: '',
							lat: '',
					},
			})
		});
	}

	catchAndInitPage = () => {
		let recommendHouse = cacheUtil.getCache(CacheKeyEnum.recommend_List) || [];
    let positionInfo =cacheUtil.getCache(CacheKeyEnum.positionInfo_List) || {};
    let isPositionSucc =cacheUtil.getCache(CacheKeyEnum.isPositionSucc_List) || false;
    let pageNo =cacheUtil.getCache(CacheKeyEnum.nowPageNo_List) || 1;
    let scrollY = cacheUtil.getCache(CacheKeyEnum.pageScrollY_List) || 0;

    this.pageScrollY = scrollY
    this.recommendHouseParams.pageNo = pageNo
		this.setState({
			recommendHouse,
			positionInfo,
			isPositionSucc
		},()=> {
			setTimeout(()=> {
				if (this.zufangPageScrollView && this.zufangPageScrollView.current) {
						this.zufangPageScrollView.current.scrollTo({
								x: 0,
								y: scrollY,
								animated: false,
						});
				}
			}, 500)
		})
		cacheUtil.clearCacheFlag('_list')
	}

	componentDidMount() {
		if (isWeb) {
			document.title = '京东写字楼'
		}
		this.getConditionData()
		setTimeout(()=>{
			const visibleList = this._getVisibleItems();
			this._sendExpoData(visibleList);

			if (isWeb) {
				const { title, url, shareImg, content } = this.getShareContent()
				if (isJDAppWebView() && typeof JdShare !== 'undefined' && !isHarmonyWeb()) {
					JdShare.setShareInfo({
						title, url, shareImg, content,
						img: shareImg,
						channel: '',
						callback: null,
						clickcallback: null,
						qrparam: null,
						timeline_title: '',
					})
				}
				if (isHarmonyWeb()) {
					harmonyWebShare({
						title, url, shareImg, content
					})
				}
			}

		},100)
		
	}

	_changePositionInfo = (res) => {
		const {isPositionSucc,cityId, cityName, open, lat, lon } = res
		const nowCityId = open ? cityId : 1
		const nowCityName = open ? cityName : '北京'
		this.getAreaList(nowCityId)
		sendPv({ pageId: Page_Id, pageParam: '' + nowCityId });
		this.setState({
				isPositionSucc,
				positionInfo: {
						cityId,
						cityName,
						open,
						lon,
						lat
				},
				cityInfo:{
					cityId: nowCityId,
					cityName: nowCityName
				}
		},() => {this.getListData()})
}

	/**
 * @description 处理页面滚动逻辑
 * @memberof Index
 */
	_handleScroll = ({
		nativeEvent: {
			contentOffset: { x, y },
			layoutMeasurement: { height: layoutHeight, width: layoutWidth },
			contentSize: { height, width }
		},
	}) => {
		// 横向滚动，也会触发该事件，要特殊处理一下
		if (isWeb && x > 0) return;

		if (this.state.showPop) {
			return false
		}

		this.pageScrollY = y

		if (isWeb) {
			if (y > (this.tabOffsetTop - this.HeadTitleHeight)  && !this.state.isTabSticky && this.tabOffsetTop !=0) {
				this.setState({
					isTabSticky: true
				});
			} else if (y < (this.tabOffsetTop - this.HeadTitleHeight) && this.state.isTabSticky) {
				this.setState({
					isTabSticky: false
				});
			} else {
			}
		} else {
			if (y > (this.tabOffsetTop - NAVIGATION_BAR_HEIGHT - SYS_BAR_HEIGHT)  && !this.state.isTabSticky) {
				this.setState({
					isTabSticky: true
				});
			} else if (y < (this.tabOffsetTop - NAVIGATION_BAR_HEIGHT - SYS_BAR_HEIGHT) && this.state.isTabSticky) {
				this.setState({
					isTabSticky: false
				});
			} else {
			}
		}

		if (y + layoutHeight >= (height - 20) && !this.recommendHouseParams.isLoading) {
			this.getListData()
		}

		const visibleList = this._getVisibleItems();
		this._sendExpoData(visibleList);

	}

	// 获取list
	getListData = () => {
		if (this.recommendHouseParams.noMoreData) {
			return false
		}
		const { keyWord, searchObj, cityInfo, positionInfo } = this.state
		const params = {
			...searchObj,
			title: keyWord,
			cityId: cityInfo.cityId,
			pageNum: this.recommendHouseParams.pageNo,
			pageSize: this.pageSize,
			longitude: positionInfo.lon || '',
			latitude: positionInfo.lat || '',
		}
		if (this.recommendHouseParams.pageNo === 1) {
			this.exposedList = [];
			layoutData = [];
			this.replaceUrl({...searchObj,title: encodeURI(keyWord),cityId: cityInfo.cityId,})
		}

		this.recommendHouseParams.isLoading = true
		getZufangSearchList(params).then(res => {
			const { code, totalCount, data } = res || {}
			if (code === 0 && totalCount) {
				if (data && data.length > 0) {
					this.setState({
						recommendHouse: this.state.recommendHouse.concat(data)
					})
				}
				if (this.recommendHouseParams.pageNo * this.pageSize > totalCount) {
					this.recommendHouseParams.noMoreData = true;
					this.setState({
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: true,
							hasNext: false
						}
					});
				} else {
					this.recommendHouseParams.noMoreData = false;
					this.setState({
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: false,
							hasNext: true
						}
					});
				}
				this.recommendHouseParams.pageNo += 1;
			} else if (code === 0 && totalCount ==0) {
				// 没有搜索到房源
			}
			
			this.recommendHouseParams.isLoading = false;
		}).catch(err => {
			this.recommendHouseParams.isLoading = false;
			this.recommendHouseParams.noMoreData = false;
			this.setState({
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: false,
					hasNext: true
				}
			});
		})
	};


getConditionData = () => {
	getZufangSearchCondition({}).then((res) => {
			const { code, data, msg } = res
			if (code == 0) {
				const nearL = res.nearbyCondition || []
				this.setState({
					searchCondition:{
						totalPriceList: res.totalPriceList || [],
						unitPriceList: res.unitPriceList || [],
						structureAreaList: res.structureAreaList || [],
						labelList: res.labelList || [],
						nearbyCondition: [{name:'全部',id:0}].concat(nearL)
					}
				})
			}
		})
		.catch((err) => {
		});
}

getAreaList = (cityId) => {
	const param = {secondCode: cityId}
	getZufangAreaList(param).then((res) => {
			const { code, citys, msg } = res
			if (code == 0 && citys && citys.length > 0) {
				const citysAll = [{thirdCode: 0, thirdName:'全部',childList:[]}]
				const allCity = citysAll.concat(citys)
				this.setState({
					areaList: allCity
				})
			} else {
				this.setState({
					areaList: []
				})
			}
		})
		.catch((err) => {
		});
}

searchParamsBack = (obj) => {
	const { searchObj } = this.state;
	const allParamsObj = Object.assign({}, searchObj, obj);
	Object.keys(allParamsObj).forEach(item => {
		if (isEmptyObj(allParamsObj[item])) {
			delete allParamsObj[item];
		}
	});
	if (JSON.stringify(allParamsObj) !== JSON.stringify(searchObj)) {
				this.exposedList = [];
				layoutData = [];
				this.recommendHouseParams = {
					pageNo: 1,
					isLoading: false,
					noMoreData: false
				}
				this.setState({
						searchObj: allParamsObj,
						recommendHouse: [],
						isTabSticky: false,
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: false,
							hasNext: true
						}
				},() => {
					this.getListData()
				});
				this.zufangPageScrollView.current.scrollTo({
						x: 0,
						y: 1,
						animated: false
				});
				this.pageScrollY = 1
	}
}

inputGoSearch = (keyword) => {
	if (keyword === this.state.keyWord){
		this.setState({
			showPopSearch: false,
		})
	} else {
		this.exposedList = [];
		this.recommendHouseParams = {
			pageNo: 1,
			isLoading: false,
			noMoreData: false
		}
		this.setState({
			recommendHouse: [],
			keyWord: keyword,
			showPopSearch: false,
			searchObj:{},
			isTabSticky: false,
			statusData: {
				isListFetching: false,
				error: null,
				firstGet: false,
				isLastPage: false,
				hasNext: true
			}
		}, () => {
			this.getListData()
		})
	}
}

	replaceUrl = (searchobj) => {
		const pageUrlObj = Object.assign({}, searchobj, {cityName: encodeURI(this.state.cityInfo.cityName)});
		Object.keys(pageUrlObj).forEach(item => {
				if(isEmptyObj(pageUrlObj[item])) {
						delete pageUrlObj[item]
				}
		})
		delete pageUrlObj.nearId
		this.nowUrlObj = pageUrlObj
		if (!isWeb) {return}
		this.context.router.replace('zufangList', pageUrlObj);
	}
	// 获取分享的数据
	getShareContent = () => {
		const {
				title, 
				countyId, 
				streetIds, 
				minRentPrice,
				maxRentPrice,
				minTradePrice,
				maxTradePrice,
				roomAreaIds,
				houseType,
				subHouseType,
				cityId,
				cityName
		} = this.nowUrlObj
    const titleURI = title ? `&title=${title}&rn_title=${title}` : '';
		const countyIdURI = countyId ? `&countyId=${countyId}&rn_countyId=${countyId}` : '';
		const streetIdsURI = streetIds ? `&streetIds=${streetIds}&rn_streetIds=${streetIds}` : '';
		const minRentPriceURI = minRentPrice ? `&minRentPrice=${minRentPrice}&rn_minRentPrice=${minRentPrice}` : '';
		const maxRentPriceURI = maxRentPrice ? `&maxRentPrice=${maxRentPrice}&rn_maxRentPrice=${maxRentPrice}` : '';
		const minTradePriceURI = minTradePrice ? `&minTradePrice=${minTradePrice}&rn_minTradePrice=${minTradePrice}` : '';
		const maxTradePriceURI = maxTradePrice ? `&maxTradePrice=${maxTradePrice}&rn_maxTradePrice=${maxTradePrice}` : '';
		const roomAreaIdsURI = roomAreaIds ? `&roomAreaIds=${roomAreaIds}&rn_roomAreaIds=${roomAreaIds}` : '';
		const houseTypeURI = houseType ? `&houseType=${houseType}&rn_houseType=${houseType}` : '';
		const subHouseTypeURI = subHouseType ? `&subHouseType=${subHouseType}&rn_subHouseType=${subHouseType}` : '';
		const cityIdURI = cityId ? `&cityId=${cityId}&rn_cityId=${cityId}` : '';
		const cityNameURI = cityName ? `&cityName=${cityName}&rn_cityName=${cityName}` : '';
		const finalUrlObj = titleURI + countyIdURI + streetIdsURI + minRentPriceURI + maxRentPriceURI + minTradePriceURI + maxTradePriceURI + roomAreaIdsURI + houseTypeURI + subHouseTypeURI + cityIdURI + cityNameURI;
		return {
			title: '京东写字楼，京选好房源',
			url: 'https://esfr.m.jd.com/zufangList?' + finalUrlObj,
			shareImg: 'https://misc.360buyimg.com/business/house/static/img/sharelogo.png',
			content: '多房源，快咨询，好品质，低价格',
		}
	}
	_onHide = () => { // 隐藏错误提示
		this.setState({
			errMsg: null,
			isShowErrMsg: false
		});
	};

	showErrFunc = (msg) => {
		this.setState({
			errMsg: msg,
			isShowErrMsg: true
		}, ()=> setTimeout(()=>{
			this._onHide()
		},3000))
	}
	showMainTabClick = (bool) => {
		if (isWeb) {
			this.tabBarRef.current && this.tabBarRef.current.measure((fx, fy, width, height, px, py) => {
				this.tabHeight = height;
			});
		}

    this.setState({
      showPop: bool
    });
	}

	_onTabBarLayout = ({
    nativeEvent: {
      layout: { y, height }
    }
  }) => {
    this.tabOffsetTop = y ;
		this.tabHeight = height;
  }

	_handleBeforeJump = () => {
		const {
			recommendHouse,
			positionInfo,
			isPositionSucc,
		} = this.state
		cacheUtil.setCache(CacheKeyEnum.recommend_List, recommendHouse);
		cacheUtil.setCache(CacheKeyEnum.positionInfo_List, positionInfo);
		cacheUtil.setCache(CacheKeyEnum.isPositionSucc_List, isPositionSucc);
		cacheUtil.setCache(CacheKeyEnum.nowPageNo_List, this.recommendHouseParams.pageNo);
		cacheUtil.setCache(CacheKeyEnum.pageScrollY_List, this.pageScrollY);
		cacheUtil.setCacheFlag('_list');
  }
	_showSearchPage = () => {
    this.setState({
      showPopSearch: true
    }, ()=>{
        // this.popSearchRef && this.popSearchRef.onSearchInputFocus && this.popSearchRef.onSearchInputFocus();
        // isWeb && this.context.router.push('zufang','#'); // todo 因为需要屏蔽一次H5浏览器返回
    })
	}
	_showCityPickerClick = () => {
    this.setState({
      isShowCityPicker: true
    })
	}
	_deletWordFocus = () => {
		this.setState({
      showPopSearch: true
    }, ()=>{
        this.popSearchRef && this.popSearchRef.current && this.popSearchRef.current.deletWordFocus && this.popSearchRef.current.deletWordFocus();
    })
  }

	handleCityChange = (cityInfo) => {
		this.setState({
			cityInfo: cityInfo,
			isShowCityPicker: false,
			recommendHouse: [],
			keyWord: '',
			searchObj:{},
			isTabSticky: false
		},() => {
			// 一整个页面开始重新加载，包括缓存 todo
			this.exposedList = [];
			layoutData = [];
			this.recommendHouseParams = {
				pageNo: 1,
				isLoading: false,
				noMoreData: false
			}
			this.setState({
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: false,
					hasNext: true
				}
			});
			this.getAreaList(cityInfo.cityId)
			this.getListData()
		})
	}

	
	_separator() {
		return <JDText style={styles.rowLine}></JDText>
	}

	toZufangDetail= (skuId, index) => {
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_SearchList_HouseResource',
			page_id: Page_Id,
			json_param: {
				skuid: skuId + '',
				sku_order: index + ''
			},
		})

		if(isWeb){
			if (!isJDApp) {
				this._handleBeforeJump()
			}
			this.setState({
			}, () => {
				const url = `https://esfr.m.jd.com/zufangDetail?skuId=${skuId}&routerName=zufangDetail`
			jumpByUrl(url)
			})
		}else{
			this.context.router['toZufangDetail']({
				skuId: skuId
			});
		}
	};

	_scrollToTop = (animated = true) => {
    if (this.zufangPageScrollView && this.zufangPageScrollView.current) {
        this.zufangPageScrollView.current.scrollTo({
            x: 0,
            y: 0,
            animated,
        });
    }
	}

	_onViewableItemsChanged = (e) => {
		const {
				changed,
				viewableItems
		} = e;
		if (changed.length > 0 && viewableItems.length > 0) {
			for (let j = 0; j < changed.length; j++) {
				const {index, item} = changed[j] || {}
				sendExposureData({
					event_id: 'OfficeBuilding_SearchList_HouseResource_expo',
					page_id: Page_Id,
					json_param: {
						skuid: item ? item.skuId + '' : '',
						sku_order: index + ''
					},
				})
			}
		}
	}

	/**
   * 过滤掉已经曝光过的数据
   */
  _filterUnExposedItems(dataList) {
		return dataList.filter(item => {
				return !this.exposedList.some(exposed => {
						return item.item.skuId === exposed.item.skuId;
				});
		}) || [];
	}
	_sendExpoData(dataList) {
		const itemsToExpo = this._filterUnExposedItems(dataList);
		if (itemsToExpo.length > 0) {
			this.exposedList = this.exposedList.concat(itemsToExpo);
			itemsToExpo.forEach(item => {
					sendExposureData({
						event_id: 'OfficeBuilding_SearchList_HouseResource_expo',
						page_id: Page_Id,
						json_param: {
							skuid: item ? item.item.skuId + '' : '',
							sku_order: item.index + ''
						},
					})
			});
		}	
}
_getVisibleItems = () => {
	const viewportStart = Math.abs(wrapperLayoutTop - this.pageScrollY);
	const viewportEnd = JDDevice.height + this.pageScrollY;
	const visibleList = layoutData.filter(layoutItem => {
			const itemLayout = layoutItem.layout;
			if (itemLayout.top + itemLayout.height + wrapperLayoutTop > viewportStart && itemLayout.top + wrapperLayoutTop < viewportEnd) {
					return true;
			}
			return false;
	});
	return visibleList;
}
_onWrapperLayout = (e) => {
	this.containerRef.current && this.containerRef.current.measure && this.containerRef.current.measure((fx, fy, w, h, px, py) => {
		wrapperLayoutTop = Math.max(wrapperLayoutTop, py);
	});
};
_onItemContainerLayout = (e, item, index) => {
	const containerLayout = e.nativeEvent.layout;
	layoutData.push({
		layout: { ...containerLayout, ...{ top: containerLayout.y } },
		item: item,
		index: index
	});
};

	render() {
		let {
			keyWord,
			isErrPage,
			isLoading,
			searchCondition,
			areaList,
			searchObj,
			cityInfo,
			isTabSticky,
			showPopSearch,
			isShowCityPicker,
			positionInfo,
			isPositionSucc,
			recommendHouse
		} = this.state;
		let titleName = '京东写字楼';
	
		return (
			<View style={styles.page}>
				<JDCNavigationBar
					renderMiddle={() => <View style={styles.navMiddBox}>
						<JDText style={styles.navMiddText}>{ titleName }</JDText>
						<View style={styles.navShareView}>
							<JDTouchable style={styles.shareIconBox} key="shareIcon"
								onPress={() => {
									const { title, url, shareImg, content } = this.getShareContent()
									JDShare.showShareDialog(url, title, content, shareImg)
								}}
							>
								<JDImage source={ shareBlack} style={styles.shareIcon} />
							</JDTouchable>
						</View>
					</View>}
					hasShare={false}
					showMoreButton={true}
					containerStyle={{}}
					barContainerStyle={{ backgroundColor: '#f6f6f6' }}
					bgStyle={{ backgroundColor: '#f6f6f6' }}
					ref={this.navBar}
					theme={'dark'}
				/>
				
				{isLoading && <View style={styles.skeletonpageBox}>
						<JDImage
							style={styles.skeletonImg}
							source={skeletonImg}
						></JDImage>
					</View>
				}
				{isErrPage && <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>当前活动太火爆啦！请稍后重试！</JDText>
					<JDText style={styles.errpageTip}>请点击按钮重新加载</JDText>
					<JDTouchable onPress={this.queryDetailHouseResource}>
						<View style={styles.errpageBtn}>
							<JDText style={styles.errpageBtnText}>重新加载</JDText>
						</View>
					</JDTouchable>
				</View>}

				<JDScrollView
          scrollEnabled={true}
          showsVerticalScrollIndicator={false}
          style={[ styles.scrollContainer, (isErrPage ? {'display':'none'} : null )]}
          scrollToTop={true}
          overScrollMode={'never'}
          bounces={false}
          ref={this.zufangPageScrollView}
          scrollEventThrottle={16}
          onScroll={this._handleScroll}
          onScrollEndDrag={this._handleScroll}
          onMomentumScrollEnd={this._handleScroll}
          optimizedMode
        >
						<View style={styles.barMeBox}></View>
						{/* 搜索框 */}
						<SearchBanner
								customStyle={{
										width: JDDevice.getRpx(702),
										marginTop: JDDevice.getRpx(28),
										marginBottom: JDDevice.getRpx(28),
								}}
								showCityPickerClick={this._showCityPickerClick}
								cityName={cityInfo.cityName}
								placeholder={'请输入楼盘/商圈'}
								keyword={keyWord}
								deletWordFocus={this._deletWordFocus}
								search={this._showSearchPage}
						/>
							{/* 筛选框 */}
						<View onLayout={(e) =>this._onTabBarLayout(e)} ref={this.tabBarRef} style={{ zIndex: 101, marginTop: -2 }}>
								<MaintabSearch
									customStyle={{ borderRadius: pt(12) }}
									showMainTabClick={this.showMainTabClick}
									talkParams={this.searchParamsBack}
									webModalBoxId={webModalBoxId}
									pageId={Page_Id}
									showNear={isPositionSucc && positionInfo.cityId == cityInfo.cityId}
									tabBarCustomStyle={{}}
									fristCode={cityInfo.cityId}
									areaList={areaList}
									NearList={searchCondition.nearbyCondition}
									searchObj={searchObj}
									priceObj={
										{totalPriceList: searchCondition.totalPriceList,
										unitPriceList: searchCondition.unitPriceList}
									}
									mainjiList={searchCondition.structureAreaList}
									typeList={searchCondition.labelList}
									pageScrollY = {0}
								/>
						</View>
							{/*房源列表*/}
							{
								recommendHouse && recommendHouse.length > 0 && (
									<View style={styles.houseSourceContainer}>
										<View style={{ marginBottom: JDDevice.getRpx(15) }} ref={this.containerRef} onLayout={this._onWrapperLayout}>
											{
												recommendHouse.map((item, index) => {
													return <View key={index+'_flatlistitem'} onLayout={(event) => this._onItemContainerLayout(event, item, index)}><JDTouchable onPress={() => this.toZufangDetail(item.skuId, index)}>
													<HouseSourceItem pageId={Page_Id} recommendHouseItem={item} index={index} ></HouseSourceItem>
												</JDTouchable></View>
												})
											}
											<FlatListFooter data={this.state.statusData}/>
										</View>
									</View>
								)
							}
							{
								recommendHouse.length === 0 && (
									<View style={styles.emptyContainer}>
										<EmptyCard textOne={'没有找到合适的房源'} textTwo={'换个条件试试'}></EmptyCard>
									</View>
								)
							}
				</JDScrollView>
				
				{/* 吸顶筛选框 */}
        {isTabSticky ? <View style={styles.isXiding_normal}>
          <View style={{ zIndex: 101 }}>
            <MaintabSearch
              customStyle={{ borderRadius: pt(12) }}
              showMainTabClick={this.showMainTabClick}
              talkParams={this.searchParamsBack}
              webModalBoxId={webModalBoxId}
              pageId={Page_Id}
							showNear={isPositionSucc && positionInfo.cityId == cityInfo.cityId}
							tabBarCustomStyle={{}}
							fristCode={cityInfo.cityId}
							searchObj={searchObj}
							areaList={areaList}
							NearList={searchCondition.nearbyCondition}
							priceObj={
								{totalPriceList: searchCondition.totalPriceList,
								unitPriceList: searchCondition.unitPriceList}
							}
							mainjiList={searchCondition.structureAreaList}
							typeList={searchCondition.labelList}
              // pageScrollY={100}
            />
          </View>
        </View> : null}

				{/* 搜索中间页 */}	
				<JDModal visible={showPopSearch} transparent={true}>
						<View style={styles.popSearchView}>
									{/* <View style={styles.barMeBox}></View> */}
									{
									<JDCNavigationBar
											beforeBack={()=>{
												this.setState({
													showPopSearch: false
												});
											}}
											renderMiddle={() => <View style={styles.navMiddBox}><JDText style={styles.navMiddText}>{ '搜索' }</JDText></View>}
											showMoreButton={false}
											containerStyle={{}}
											barContainerStyle={{ backgroundColor: 'transparent' }}
											bgStyle={{}}
											theme={ 'dark'}
										/>
									}
									<SearchPage
											ref={this.popSearchRef}
											goSearchKeyword={this.inputGoSearch}
											placeholder={'请输入楼盘/商圈'}
											keyword={keyWord}
											cityName={cityInfo.cityName}
											cityId={cityInfo.cityId}
											pageId={Page_Id}
											isIconShow={isWeb ? false : true}
											beforeBack={()=>{
												this.setState({
													showPopSearch: false
												})
											}}
											searchPageViewStyle={{paddingLeft: JDDevice.getRpx(32)}}
									/>
						</View>
				</JDModal>

				{/* 城市选择组件 */}
        <JDModal visible={isShowCityPicker} transparent={true}>
          <View style={styles.cityListPop}>
						{
							<JDCNavigationBar
								beforeBack={()=>{
									this.setState({
										isShowCityPicker: false
									});
								}}
								renderMiddle={() => <View style={styles.navMiddBox}><JDText style={styles.navMiddText}>{ '选择城市' }</JDText></View>}
								showMoreButton={false}
								containerStyle={{}}
								barContainerStyle={{ backgroundColor: 'transparent' }}
								bgStyle={{}}
								theme={ 'dark'}
							/>
						}
            <CityList
							changePositionInfo={this._changePositionInfo}
							changeCityClick={this.handleCityChange}
							positionInfo={positionInfo}
							isPositionSucc={isPositionSucc}
							pageCityId={cityInfo.cityId}
						/>
          </View>
        </JDModal>
				{ isTabSticky && <FloatEntry
                    iconUrl="https://img14.360buyimg.com/imagetools/jfs/t1/181974/22/28618/593/6316b699E492ad966/762dd3c069e215ba.png"
                    onPress={this._scrollToTop}/>
        }
				{
					isPhoneX() && (<View style={styles.iphoneXDiv} />)
				}
				{/*错误信息提示模块*/}
				<JDToast show={this.state.isShowErrMsg} onHide={this._onHide} style={styles.toastStyle} mode={JDToast.MODE.MODAL}>
					{this.state.errMsg}
				</JDToast>
				{
						isWeb && <div id="maintabsearchModal"></div>
				}
			</View>
		)
	}
}

const styles = StyleSheet.create({
  page: {
		position: 'relative',
		backgroundColor: '#f6f6f6',
		flex: 1,
	},
	navShareView: {
		position: 'absolute',
		top: 0,
		right: 0
	},
	shareIconBox: {
		width: JDDevice.getRpx(88),
		height: JDDevice.getRpx(88)
	},
	shareIcon: {
		width: JDDevice.getRpx(44),
		height: JDDevice.getRpx(44),
		marginTop: JDDevice.getRpx(22),
		marginLeft: JDDevice.getRpx(22),
	},
	scrollContainer: {
		flex: 1,
		overflow: 'visible',
		paddingHorizontal: pt(24)
	},
	lunboWarp: {
		backgroundColor: '#ffffff',
		marginBottom: pt(22),
		height: pt(264),
		borderRadius: pt(18)
	},
	bannerWrap: {
		backgroundColor: '#ffffff',
		marginBottom: pt(10),
		paddingVertical: pt(30),
		borderRadius: pt(24)
	},
	// 推荐房源
	houseSourceContainer: {
		backgroundColor: "#fff",
		paddingBottom: JDDevice.getRpx(12),
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24)
	},
	// 推荐房源
	emptyContainer: {
		paddingBottom: JDDevice.getRpx(12),
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24)
	},
	toastStyle: {
		backgroundColor: "rgba(0,0,0,0.6)"
	},
	image: {
		width: JDDevice.width,
		height: JDDevice.getRpx(420),
		resizeMode: 'stretch'
	},
	brokerFooter: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 2,
		height: JDDevice.getRpx(150),
		width: JDDevice.getRpx(750),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#fff',
		borderTopLeftRadius: JDDevice.getRpx(48),
		borderTopRightRadius: JDDevice.getRpx(48),
		paddingHorizontal: JDDevice.getRpx(36),
		paddingTop: JDDevice.getRpx(30),
		...Platform.select({ // 不同的平台执行不同的阴影样式
			ios: {
				shadowColor: '#000',
				shadowOffset: { h: 0, w: JDDevice.getRpx(10) }, // ios设置阴影
				shadowOpacity: 0.05
			},
			web: {
				boxShadow: '0 -3px 10px rgba(0,0,0,0.05)'
			}
		}),
	},

	iphoneXDiv: {
		width: JDDevice.getRpx(750),
		height: 17,
		backgroundColor: '#F0F2F5'
	},
	paddingDiv: {
		marginHorizontal: JDDevice.getRpx(24),
	},
	skeletonpageBox:{
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%',
		overflow:'hidden'
	},
	skeletonImg:{
		width: '100%',
		height:'100%',
	},
	errpageBox: {
		position: 'absolute',
		top: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%'
	},
	errpageImg: {
		width: JDDevice.getRpx(378),
		height: JDDevice.getRpx(392),
	},
	errpageText: {
		fontSize: JDDevice.getRpx(32),
		color: '#808080',
		paddingVertical: JDDevice.getRpx(6),
	},
	errpageTip: {
		fontSize: JDDevice.getRpx(26),
		color: '#808080',
	},
	errpageBtn: {
		width: JDDevice.getRpx(200),
		height: JDDevice.getRpx(88),
		borderRadius: JDDevice.getRpx(44),
		borderColor: '#FA2C19',
		borderWidth: JDDevice.getDpx(1),
		marginTop: JDDevice.getRpx(44),
		justifyContent: 'center'
	},
	errpageBtnText: {
		fontSize: JDDevice.getRpx(34),
		color: '#FA2C19',
		textAlign: 'center'
	},
	navMiddBox: {
		width: '100%',
		height: JDDevice.getRpx(88),
		justifyContent: 'center',
		alignItems: 'center'
	},
	navMiddText: {
		fontSize: JDDevice.getRpx(32),
		color: '#2E2D2D',
	},
	barMeBox: {
    width: JDDevice.width,
    height: justLiulanqiHead,
		backgroundColor: '#F6F6F6'
  },
	isXiding_normal: {
    zIndex: 500,
    position: 'absolute',
    top:  justLiulanqiHead,
    width: JDDevice.width,
		paddingHorizontal: pt(24)
  },  
	popSearchView: {
		width: JDDevice.width,
		height: JDDevice.height + SYS_BAR_HEIGHT,
		backgroundColor: '#f6f6f6',
	},
	cityListPop: {
		width: '100%',
    height: '100%',
    backgroundColor: '#fff'
	},
});
module.exports = ZufangSearch;